/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';
import ProductService from '../services/product-service.js';

var _registerToActions = function(action){

    console.log(action)

    switch(action.actionType)
    {
        case Constants.GET_ACCOUNT_STUDENTS_HIGHSCORE:
            this.accountStudentsHighscore = action.response
            this.emit(Constants.GET_ACCOUNT_STUDENTS_HIGHSCORE);
            break;
        case Constants.GET_CLASSES_HIGHSCORE:
            this.classesHighscore = action.response
            this.emit(Constants.GET_CLASSES_HIGHSCORE);
            break;
        case Constants.GET_CLASSES_STUDENTS_HIGHSCORE:
            this.studentsHighscore = action.response
            this.emit(Constants.GET_CLASSES_STUDENTS_HIGHSCORE);
            break;
    }

};

class ReportScore extends BaseStore{

    constructor(){
        super();
        this.subscribe(() => _registerToActions.bind(this));
        this.languages =  [];
    }

}

export default new ReportScore();